const cookieHelpers = require("../../../../scripts/helpers/cookieHelpers");

// DGF-4958: one Wishlist-CheckAvailability request at a time. Fave then unfave in quick succession would
// otherwise send two, and if the first answered last the dot - and the cookie the server writes with each answer -
// would describe the older list. A check made while one is in flight marks it stale; when it lands, its answer is
// dropped and the check runs again against the list as it is then, so the last answer is always the current one.
let inFlight = false;
let stale = false;

/**
* Checks the availability of the wishlist notification and updates its visibility in the header.
* The dot is the wishlist low-stock alert: shown while any item in the wishlist is low in stock. It is decided by
* Wishlist-CheckAvailability, which caches its answer in the wishlistNotification cookie.
* Only operates if the wishlist header, icon, and notification dot are present.
*
* @function
* @param {boolean} [refresh] - true to ask the server again rather than read the cookie, as after the wishlist
*     changes. The server rewrites the cookie with the new answer.
* @returns {void}
*/
const checkWishlistAvailability = (refresh) => {
    const wishlistHeader = $(".js-header-wishlist");
    // The header heart is the icon-set SVG pair now, filled while the list has items (headerWishList.isml)
    const icon = wishlistHeader.find(".js-wishlist-heart");
    const wishlistURL = wishlistHeader.data("action-url");
    const wishlistNotification = wishlistHeader.find(".notification-dot");

    if (!wishlistURL || !wishlistNotification.length || !icon.length) {
        return;
    }

    const setNotificationVisibility = (isVisible) => {
        wishlistNotification.toggleClass("d-none", !isVisible);
    };

    // DGF-4958: an empty list has nothing low in stock. Hidden explicitly rather than left as rendered, because a
    // cookie from before the list was emptied can still say "true".
    if (!icon.hasClass("is-filled")) {
        setNotificationVisibility(false);
        stale = inFlight;
        return;
    }

    // Check if the cookie exists and its value
    const wishlistWarning = refresh ? undefined : cookieHelpers.getCookie("wishlistNotification");

    if (wishlistWarning === undefined) {
        if (inFlight) {
            stale = true;
            return;
        }

        inFlight = true;
        fetch(wishlistURL, { cache: "no-store" })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => data.success === true)
            .catch(() => false)
            .then(isVisible => {
                inFlight = false;
                if (stale) {
                    stale = false;
                    checkWishlistAvailability(true);
                    return;
                }
                setNotificationVisibility(isVisible);
            });
    } else {
        setNotificationVisibility(wishlistWarning === "true");
    }
};

module.exports = function () {
    checkWishlistAvailability();
};

// DGF-4958: after an add or remove, so the dot reflects the list as it now is
module.exports.refresh = function () {
    checkWishlistAvailability(true);
};
